import type { InputHTMLAttributes, ReactNode } from 'react';
import { forwardRef } from 'react';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: ReactNode;
}

export const Checkbox = forwardRef<HTMLInputElement, Props>(function Checkbox(
  { label, className = '', ...rest }, ref,
) {
  return (
    <label className={`check ${className}`.trim()}>
      <input ref={ref} type="checkbox" {...rest} />
      <span className="box" aria-hidden="true">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M2 6.5L5 9L10 3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      {label && <span>{label}</span>}
    </label>
  );
});
